import React from "react";
import InstallAppButton from "./InstallAppButton";
import { useInstall } from "@/contexts/InstallContext";

export default function PwaPromoBanner({ className = "" }) {
  const { canInstall } = useInstall();
  if (!canInstall) return null;

  return (
    <div className={`rounded-2xl bg-black text-white px-6 py-6 md:px-10 md:py-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 ${className}`}>
      <div>
        <h3 className="text-lg md:text-2xl font-bold tracking-tight">Want to explore more?</h3>
        <p className="text-white/60 text-sm mt-1">
          Get notified the moment you're selected — install the app for a faster, distraction-free experience.
        </p>
      </div>
      <InstallAppButton variant="light" className="h-11 sm:px-7 w-full sm:w-auto justify-center" />
    </div>
  );
}
